export default __webpack_public_path__ + "0bd5780a60eb6f6d1d8a507c11b7b84a.svg";